import { PLACEHOLDER_IMG_URL } from '@/constants/images';
import type { AssetGroup } from '@/types/asset';

export const getImageData = (asset: AssetGroup) => {
  const { type, data } = asset;
  let artistName = '';

  if (type === 'motion') {
    artistName = data?.contributor?.name ?? '';
  } else if (type === 'stock_footage') {
    artistName = data.contributor_name;
  } else {
    artistName = data?.artist?.name ?? '';
  }

  switch (type) {
    case 'music':
      return {
        imgSrc:
          data?.artist?.avatar_image?.image_aws_url ?? PLACEHOLDER_IMG_URL,
        imgAlt: artistName ?? 'Author',
        assetName: data.name ?? 'Track',
        artistName,
      };
    case 'sfx':
      return {
        imgSrc:
          data?.sfx_classification_id?.preview_image ??
          data?.artist?.avatar_image?.image_aws_url ??
          PLACEHOLDER_IMG_URL,
        imgAlt: artistName ?? 'Author',
        assetName: data?.name ?? 'Sound Effect',
        artistName,
      };
    case 'motion':
      return {
        imgSrc: data?.image ?? PLACEHOLDER_IMG_URL,
        imgAlt: data?.name ?? 'motion graphic image',
        assetName: data?.name ?? 'Motion Graphics',
        artistName: artistName ?? '',
        file_size: data?.file_size,
        compatibility: data?.compatibility,
        compatibilityNode: data?.compatibilityNode,
        software_version: data?.software_version,
      };
    case 'stock_footage':
      return {
        imgSrc: data?.thumbnail_url ?? PLACEHOLDER_IMG_URL,
        imgAlt: data?.title ?? 'stock video image',
        assetName: data?.title ?? 'Stock Video',
        artistName: artistName ?? '',
        file_size: {
          file_size_bytes_720p: data.file_size_bytes_720p,
          file_size_bytes_1080p: data.file_size_bytes_1080p,
          file_size_bytes_4k: data.file_size_bytes_4k,
        },
      };
    default:
      return {
        imgSrc: PLACEHOLDER_IMG_URL,
        imgAlt: 'Unknown',
        assetName: 'Unknown Asset',
        artistName: 'Unknown Artist',
      };
  }
};
